import React, { useState } from "react";
export const StudentContext = React.createContext<any>(null);
export const StudentContextDispatch = React.createContext<any>(null);
export const StudentContextProvider = (props: any) => {
  const [student, setStudent] = useState<any>({});
  return (
    <StudentContext.Provider value={student}>
      <StudentContextDispatch.Provider value={setStudent}>
        {props.children}
      </StudentContextDispatch.Provider>
    </StudentContext.Provider>
  );
};

export const StudentPerformanceContext = React.createContext<any>(null);
export const StudentPerformanceContextDispatch = React.createContext<any>(null);
export const StudentPerformanceContextProvider = (props: any) => {
  const [studentPerformance, setStudentPerformance] = useState<any>({});
  return (
    <StudentPerformanceContext.Provider value={studentPerformance}>
      <StudentPerformanceContextDispatch.Provider value={setStudentPerformance}>
        {props.children}
      </StudentPerformanceContextDispatch.Provider>
    </StudentPerformanceContext.Provider>
  );
};
